import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import CoreButtonHoverIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import CoreDialog from "../../../app/core/components/CoreDialog/CoreDialog";
import CoreModal from "../../../app/core/components/CoreModal/CoreModal";
import { t } from "i18next";
import { useEffect, useState } from "react";
import {
  useDeletePromptMutation,
  useGetAllPromptQuery,
} from "../../api/admin/aiPromptApi";
import CoreTable from "../../../app/core/components/CoreTable/CoreTable";
import { toast } from "react-toastify";
import DetailPrompt from "./DetailPrompt";

const GestionePrompt = () => {
  const [rows, setRows] = useState([]);
  const [prompt, setPrompt] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [createAnalysis, setCreateAnalysis] = useState(true);
  const [createBIAS, setCreateBIAS] = useState(true);

  const { data, isLoading, refetch } = useGetAllPromptQuery();
  const [deletePrompt] = useDeletePromptMutation();

  const columns = [t("Name"), t("Content"), t("Type")];

  useEffect(() => {
    if (data && data.Data && data.Data.value) {
      const rowData = data.Data.value.map((el) => ({
        id: el.id,
        [t("Name")]: el.name,
        [t("Content")]: el.content,
        [t("Type")]: el.type,
      }));

      const noCreate = data.Data.value.reduce(
        (acc, el) => {
          if (el.type === "DocumentAnalysis") acc.createA = false;
          if (el.type === "DocumentAnalysisBIAS") acc.createB = false;
          return acc;
        },
        { createA: true, createB: true }
      );

      setRows(rowData);
      setCreateAnalysis(!noCreate.createA);
      setCreateBIAS(!noCreate.createB);
    }
  }, [data]);

  const handleClose = () => {
    setPrompt(null);
    setOpenModal(false);
  };
  const handleOpen = () => setOpenModal(true);

  const handleEditOpen = (el) => {
    setPrompt(el);
    setOpenModal(true);
  };
  const handleDeletePrompt = (el) => {
    setPrompt(el);
    setOpenDialog(true);
  };
  const handleCloseDelete = () => setOpenDialog(false);

  const handleConfermDialog = () => {
    deletePrompt(prompt.id).then((res) => {
      if (res.data && res.data.Result !== 1) {
        toast.error(res.data.Exception || t("NotDeletePrompt"));
        return;
      }
      toast.success(t("DeletePrompt"));
      setPrompt();
      handleCloseDelete();
    });
  };

  const actions = [
    {
      icon: <EditRoundedIcon />,
      onClick: handleEditOpen,
      tooltip: t("Edit"),
    },
    {
      icon: <DeleteIcon className={"fill-rose-600"} />,
      onClick: handleDeletePrompt,
      tooltip: t("Delete"),
    },
  ];

  return (
    <>
      <div className="w-full">
        <div className="flex flex-row items-center space-x-4">
          <h2>{t("ManagePrompt")}</h2>
        </div>

        <div className="flex pb-4 space-x-4 items-center">
          <div>
            <CoreButtonHoverIcon
              onClick={refetch}
              className="text-blue-500 m-1 flex flex-row space-x-2 border"
              testo={t("Refresh")}
              icon={<RefreshRoundedIcon className={`fill-blue-500`} />}
            />
            <CoreButtonHoverIcon
              className="text-blue-500 m-1"
              icon={<AddBoxRoundedIcon className={`fill-blue-700`} />}
              testo={`${t("Prompt")}`}
              onClick={handleOpen}
            />
          </div>
        </div>
      </div>

      <CoreDialog
        open={openDialog}
        title={`Elimina Prompt`}
        content={"Sei sicuro di eliminare Prompt"}
        negativeButton={t("No")}
        positiveButton={t("Yes")}
        handlePositive={handleConfermDialog}
        closeDialog={handleCloseDelete}
      />

      <CoreTable
        button
        actions={actions}
        rows={rows}
        columns={columns}
        isLoading={isLoading}
      />

      <CoreModal
        width={"60%"}
        height={"45%"}
        state={openModal}
        onClose={handleClose}
        component={
          <DetailPrompt
            prompt={prompt}
            onClose={handleClose}
            createAnalysis={createAnalysis}
            createBIAS={createBIAS}
          />
        }
      />
    </>
  );
};

export default GestionePrompt;
